import React from 'react';
import Imagen from '../img/photo_coach.jpeg'

export default function QuienSoy() {
    return (
        <div className='container mx-auto'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-2 py-10 m-5 '>
                <div className='flex items-center justify-center'>
                    <img src={Imagen} className='w-3/4'/>
                </div>
                <div className='flex items-center justify-center'>
                    <p className='text-xl text-justify p-2 font-times '>
                        No trabajo con motivación pasajera.
                        Trabajo con estructura, mentalidad y sistemas de alto rendimiento.<br/>
                        Soy Nelson Fernando Mendoza.
                        Durante más de 20 años he estudiado, aplicado y perfeccionado metodologías que transforman bloqueos invisibles en crecimiento estratégico y resultados sostenibles.<br/>
                         Soy Nelson Fernando Mendoza.
                        Durante más de 20 años he estudiado, aplicado y perfeccionado metodologías que transforman bloqueos invisibles en crecimiento estratégico y resultados sostenibles.<br/>
                        Mi formación integra aprendizaje en instituciones como Case Western Reserve University, Axon Trading, el Politécnico Superior de Medellín y el Instituto Deandhela.<br/>
                        A lo largo de mi trayectoria he estudiado y aplicado principios de referentes internacionales como Anthony Robbins, Alex Day, Luis Hinestroza, Tatis De Anyelo, Conny Méndez, Jim Rohn, Brian Tracy, John Maxwell, Napoleon Hill, Ray Dalio y Mario Alonso Puig, entre otros, integrando liderazgo, mentalidad estratégica, inteligencia emocional y expansión de conciencia en un modelo práctico y ejecutable.<br/>
                        Pero más allá de las certificaciones, mi mayor escuela ha sido el terreno real: ventas exigentes, liderazgo bajo presión, crisis personales, reconstrucción y formación de equipos desde cero.<br/>
                        Trabajo bajo una premisa clara:<br/>
                        Si el resultado no mejora, el sistema necesita rediseño.<br/>
                        Por eso no solo acompaño procesos.<br/>
                        Rediseño estructuras internas —mentales, emocionales y estratégicas— para que el crecimiento sea medible y sostenible.<br/>
                        Mi misión es elevar estándares, fortalecer liderazgo y convertir potencial en resultados concretos.<br/>
                        Si buscas inspiración momentánea, no soy tu mentor.<br/>
                        Si buscas evolución estructural y alto rendimiento real, estamos listos para trabajar.
                    </p>

                </div>
            </div>
        </div>
    )

}